import React, {useEffect} from 'react';
import {useDispatch} from "react-redux";
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Box from '@mui/material/Box';

import {checkCredentials} from "./store/credentialsSlice";
import Home from './pages/Home';
import Form from './pages/Form';
import NotFound from './pages/NotFound';

const mdTheme = createTheme();

export default function App() {

    const dispatch = useDispatch();

    useEffect(() => {

        dispatch(checkCredentials())
            .then((response) => {

                console.log('response', response);

            });

    }, []);

    return (
        <Router basename={'/form-editor'}>
            <ThemeProvider theme={mdTheme}>
                <Box
                    component="main"
                    sx={{
                        backgroundColor: (theme) =>
                            theme.palette.mode === 'light'
                                ? theme.palette.grey[100]
                                : theme.palette.grey[900],
                        flexGrow: 1,
                        height: '100vh',
                        overflow: 'auto',
                    }}
                >

                    <Switch>
                        <Route path="/form">
                            <Form />
                        </Route>
                        <Route path="/">
                            <Home />
                        </Route>
                        <Route path="*">
                            <NotFound />
                        </Route>
                    </Switch>

                </Box>
            </ThemeProvider>
        </Router>
    );

}